export default {
  cinema_referral: "Earn by Sharing",
  cinema_referralDesc: "Invite friends with your personal link and earn rewards",
  cinema_referralLinkTitle: "My Referral Link",
  cinema_referralLinkDesc: "New registrations through this link are attributed to you",
  cinema_referralRulesTitle: "Referral Rules",
  cinema_referralRulesCoins: "When a friend registers through your referral link, you may receive coin rewards. Coins can only be used to watch content on the platform and cannot be exchanged for cash or withdrawn.",
  cinema_referralRulesCommission: "When a friend recharges, you may earn a commission under the applicable rules. Only recharge commissions are withdrawable; once they reach ¥100, you can request a USDT withdrawal.",
  cinema_copyLink: "Copy link",
  cinema_inviteCodeLabel: "Referral code",
  cinema_inviteRuleTitle: "Referral rewards",
  cinema_inviteRuleNormal: "Members earn 20 coins for each successful registration. Rewards are recorded in coin history.",
  cinema_distributorOverview: "Distributor overview",
  cinema_availableCommission: "Available",
  cinema_totalCommission: "Total commission",
  cinema_pendingWithdrawal: "Pending withdrawal",
  cinema_withdrawnAmount: "Withdrawn",
  cinema_firstLevelRate: "Level 1 rate",
  cinema_secondLevelRate: "Level 2 rate",
  cinema_todayBrowse: "Views",
  cinema_todayRegister: "Registrations",
  cinema_todayRecharge: "Recharges",
  cinema_todayRechargeAmount: "Recharge amount",
  cinema_commissionAmount: "Commission",
  cinema_registerDetails: "Registrations",
  cinema_rechargeDetails: "Recharges",
  cinema_inviteRewards: "Referral rewards",
  cinema_goWithdraw: "Withdraw",
  cinema_noReferralData: "No referral data yet",
  cinema_referralLoadFailed: "Unable to load referral data. Please try again.",
  cinema_loginToPromote: "Sign in to create your referral link",
  cinema_totalEarnings: "Total Earnings",
  cinema_withdrawable: "Withdrawable",
  cinema_frozen: "Frozen",
  cinema_invitedCount: "Invited",
  cinema_coinUnit: "coins",
  cinema_people: "people",
  cinema_conversionStats: "Referral Conversion",
  cinema_allDatesTotal: "All dates total",
  cinema_selectedDatesTotal: "Selected date total",
  cinema_conversionStatsDesc: "Daily views, signups, recharges and commissions",
  cinema_colDate: "Date",
  cinema_colPv: "Visitors",
  cinema_colBrowseCount: "Views",
  cinema_colRegister: "Signups",
  cinema_colRechargeUsers: "Payers",
  cinema_colRechargeOrders: "Orders",
  cinema_colPaidAmount: "Amount Paid",
  cinema_colCommission: "Commission",
  cinema_colRegisterRate: "Signup Rate",
  cinema_colRechargeRate: "Recharge Rate",
  cinema_commissionRateTitle: "Commission Rate",
  cinema_currentRateLabel: "Current actual commission rate",
  cinema_baseRate: "Base Rate",
  cinema_currentRate: "Current Rate",
  cinema_earningsRecord: "Earnings Record",
  cinema_inviteDetail: "Invite Details",
  cinema_allEarnings: "All Earnings",
  cinema_filterAll: "All",
  cinema_filterPending: "Pending",
  cinema_filterSettled: "Settled",
  cinema_earningsDate: "Date",
  cinema_earningsType: "Type",
  cinema_earningsUser: "User",
  cinema_earningsAmount: "Earnings",
  cinema_earningsStatus: "Status",
  cinema_statusSettled: "Settled",
  cinema_statusPending: "Pending",
  cinema_noEarningsRecords: "No records yet",
  cinema_referralUser: "User",
  cinema_referralRegDate: "Registered",
  cinema_referralRecharged: "Total Recharged",
  cinema_referralEarned: "My Earnings",
  cinema_startDate: "Start date",
  cinema_endDate: "End date",
  cinema_query: "Search",
  cinema_dateRangeError: "The start date cannot be later than the end date",
  cinema_brand: "Huangguo TV",
  cinema_language: "Language",
  cinema_tagline: "Original AI Short Dramas, Infinite Possibilities",
  cinema_navHome: "Home",
  cinema_navCategories: "Ranking",
  cinema_rankingTitle: "Ranking",
  cinema_rankingAll: "All",
  cinema_rankingLoading: "Loading ranking...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} series · {{views}} views",
  cinema_rankingTotal: "All time",
  cinema_rankingMonth: "Monthly",
  cinema_rankingWeek: "Weekly",
  cinema_rankingLatest: "Latest",
  cinema_rankingCreator: "Creators",
  cinema_creatorLabel: "Creator",
  cinema_rankingEmpty: "No ranked series yet",
  cinema_navMyList: "My List",
  cinema_soundGuideTitle: "Tap here to turn on sound",
  cinema_soundGuideAction: "Turn on sound",
  cinema_soundGuideDismiss: "Dismiss sound guide",
  cinema_navHistory: "History",
  cinema_navAds: "Earn",
  cinema_navProfile: "Me",
  cinema_adsTitle: "Featured Ads",
  cinema_adsSubtitle: "Discover more featured content",
  cinema_adFeatured: "Featured",
  cinema_adOpen: "View Now",
  cinema_adsEmpty: "No ads available",
  cinema_adsLoadFailed: "Unable to load ads. Please try again.",
  cinema_earnTitle: "Earn Coins",
  cinema_earnSubtitle: "Check in daily and collect coins",
  cinema_earnBalance: "My Coins",
  cinema_checkInTitle: "Daily Check-in",
  cinema_checkInSubtitle: "Keep your streak to earn more coins",
  cinema_checkInDay: "Day {{day}}",
  cinema_checkInToday: "Today",
  cinema_checkInClaim: "Check in for {{points}} coins",
  cinema_checkInClaimed: "Checked in today",
  cinema_checkInLogin: "Log in to check in",
  cinema_checkInSuccess: "Check-in complete. You earned {{points}} coins",
  cinema_checkInFailed: "Check-in failed. Check your connection and try again",
  cinema_checkInNoReward: "This device has already received today's check-in reward",
  cinema_checkInStreak: "Current streak",
  cinema_checkInStreakValue: "{{days}} days",
  cinema_checkInTotal: "Total earned",
  cinema_checkInTotalValue: "{{points}} coins",
  cinema_checkInLoadFailed: "Failed to load check-in status",
  cinema_retry: "Try again",
  cinema_moreEarnWays: "More ways to earn",
  cinema_inviteEarnTitle: "Invite friends and earn",
  cinema_inviteEarnDesc: "Earn coins when a friend registers",
  cinema_goInvite: "Invite",
  cinema_earnCoinsTitle: "Earn Coins",
  cinema_earnCoinsBalance: "My Coins",
  cinema_earnCoinsSignInStreak: "You've checked in for {{count}} days",
  cinema_earnCoinsCheckIn: "Check In",
  cinema_earnCoinsCheckedIn: "Checked In",
  cinema_earnCoinsTomorrow: "Come Back Tomorrow",
  cinema_earnCoinsInviteTitle: "Invite a friend to earn",
  cinema_earnCoinsInviteCode: "My Invite Code",
  cinema_earnCoinsGoInvite: "Invite Now",
  cinema_earnCoinsLimitedTask: "Limited Task",
  cinema_earnCoinsTimeLeft: "Countdown",
  cinema_earnCoinsNewbieTask: "Newbie Tasks",
  cinema_earnCoinsDailyTask: "Daily Tasks",
  cinema_earnCoinsRecommendations: "Recommended",
  cinema_earnCoinsAdTask: "Watch Ads",
  cinema_earnCoinsAdTaskDesc: "Watch ads to earn more coins",
  cinema_earnCoinsGoWatch: "Watch Ad",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "Day {{day}}",
  cinema_earnCoinsToday: "Today",
  cinema_earnCoinsCoinUnit: "coins",
  cinema_earnCoinsAdCurrent: "Current Task",
  cinema_earnCoinsAdLocked: "Locked Task",
  cinema_earnCoinsTaskCompleted: "Completed",
  cinema_limitedRechargeTaskTitle: "Complete your first recharge within 1 hour",
  cinema_limitedRechargeTaskAction: "Recharge",
  cinema_claimReward: "Claim",
  cinema_claiming: "Claiming",
  cinema_taskClaimFailed: "Claim failed. Please try again.",
  cinema_bindEmailAction: "Bind Email",
  cinema_limitedRechargeTaskExpired: "Expired",
  cinema_watchHistory: "Watch History",
  cinema_navSearch: "Search series...",
  cinema_login: "Login",
  cinema_vip: "VIP",
  cinema_heroPlay: "Play Now",
  cinema_heroMore: "Learn More",
  cinema_hotRecommend: "Trending Now",
  cinema_carouselLoading: "Loading featured content...",
  cinema_newRelease: "New Releases",
  cinema_allSeries: "All Series",
  cinema_viewAll: "View All",
  cinema_episodes: "{{count}} Episodes",
  cinema_rating: "{{score}} Rating",
  cinema_views: "{{count}} Views",
  cinema_play: "Play",
  cinema_continueWatch: "Continue Watching",
  cinema_rewatch: "Rewatch",
  cinema_categoryAll: "All",
  cinema_categoryUrban: "Urban Romance",
  cinema_categorySuspense: "Suspense",
  cinema_categoryCostume: "Historical",
  cinema_categoryWorkplace: "Workplace",
  cinema_categorySciFi: "Sci-Fi",
  cinema_categorySciFiRomance: "Sci-Fi Romance",
  cinema_unlock: "Unlock Episode",
  cinema_unlockDesc: "Unlocking this episode costs {{cost}} coins",
  cinema_unlockConfirm: "Confirm & Play",
  cinema_cancel: "Cancel",
  cinema_balance: "Balance: {{coins}} coins",
  cinema_insufficient: "Insufficient coins, please recharge",
  cinema_unlocked: "Unlocked",
  cinema_locked: "Locked",
  cinema_episodeNumber: "Episode {{number}}",
  cinema_playing: "Now Playing",
  cinema_backToList: "Back to List",
  cinema_back: "Back",
  cinema_noSeries: "No series available",
  cinema_seriesDesc: "Synopsis",
  cinema_episodeList: "Episodes",
  cinema_nextEpisode: "Next",
  cinema_episodeEnded: "Episode Finished",
  cinema_nextEpisodePrompt: "Continue with episode {{number}}?",
  cinema_playNextEpisode: "Play Next Episode",
  cinema_prevEpisode: "Previous",
  cinema_freeLabel: "Free",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "New",
  cinema_hotLabel: "Hot",
  cinema_featuredBanner: "Must Watch This Week",
  cinema_watchNow: "Watch Now",
  cinema_searchPlaceholder: "Search for series...",
  cinema_noResults: "No series found",
  cinema_emptyMyList: "No series in your list yet",
  cinema_emptyHistory: "No watch history",
  cinema_addToMyList: "Add to My List",
  cinema_removeFromMyList: "Remove from My List",
  cinema_clearAll: "Clear All",
  cinema_footerCopy: "Huangguo TV — Premium Short Drama Platform",
  cinema_footerWarning: "Content is AI-generated for entertainment purposes. Please comply with local laws.",
  cinema_myList: "My List",
  cinema_addedAt: "Added {{date}}",
  cinema_expand: "Expand",
  cinema_collapse: "Collapse",
  cinema_historyAll: "All",
  cinema_historyUnfinished: "Unfinished",
  cinema_historyFinished: "Finished",
  cinema_historyCount: "{{count}} records",
  cinema_noHistoryFilter: "No records in this category",
  cinema_finished: "Finished",
  cinema_watchedFull: "Completed",
  cinema_welcomeBack: "Welcome Back",
  cinema_loginDesc: "Login to unlock more content",
  cinema_phoneLogin: "Phone Login",
  cinema_emailLogin: "Email Login",
  cinema_phonePlaceholder: "Enter phone number",
  cinema_emailPlaceholder: "Enter email address",
  cinema_agreeTerms: "By logging in you agree to",
  cinema_userAgreement: "User Agreement",
  cinema_privacyPolicy: "Privacy Policy",
  cinema_getCode: "Get Code",
  cinema_loginNow: "Login Now",
  cinema_otherLogin: "Other Login Methods",
  cinema_loggingIn: "Logging in...",
  cinema_loginSuccess: "Login Successful",
  cinema_loginRedirect: "Redirecting to profile...",
  cinema_profile: "Profile",
  cinema_memberLabel: "Member",
  cinema_dealerLabel: "Distributor",
  cinema_coinAmount: "{{count}} coins",
  cinema_profileAccount: "Account",
  cinema_profileContent: "Content",
  cinema_profileSettings: "Settings",
  cinema_editProfile: "Edit Profile",
  cinema_myCoins: "My Coins",
  cinema_myPurchases: "Purchased",
  cinema_downloads: "Downloads",
  cinema_playbackSettings: "Playback Settings",
  cinema_notifications: "Notifications",
  cinema_cacheManage: "Cache Management",
  cinema_about: "Contact Us",
  cinema_contactUnavailable: "Customer service is unavailable. Please try again later.",
  cinema_watchedHours: "Watch Hours",
  cinema_collectionCount: "Collections",
  cinema_logout: "Logout",
  cinema_logoutConfirm: "Confirm Logout?",
  cinema_logoutConfirmDesc: "You will need to login again to use full features",
  cinema_version: "Version {{version}}",
  cinema_rechargeTitle: "Recharge",
  cinema_rechargeSubtitle: "Select a recharge plan",
  cinema_rechargeVpnWarning: "A VPN or proxy may trigger payment risk controls, preventing the checkout from opening or causing payment to fail.",
  cinema_rechargeVpnGuideTitle: "Turn off your VPN before payment",
  cinema_rechargeVpnInstruction: "After turning off your VPN, click the button below to continue with your selected payment method.",
  cinema_rechargeVpnContinue: "VPN is off, continue to payment",
  cinema_rechargeRMB: "RMB Recharge",
  cinema_rechargeUSDT: "USDT Recharge",
  cinema_rechargeRecommended: "Recommended",
  cinema_rechargeCoins: "Coins",
  cinema_rechargeBonus: "+{{points}} bonus",
  cinema_rechargeCredited: "Get {{points}}",
  cinema_firstRechargeBannerTitle: "First recharge bonus! Extra reward on any amount",
  cinema_firstRechargeSelectedBonus: "+{{points}} coins",
  cinema_firstRechargeLimitedTitle: "Limited first recharge bonus",
  cinema_dailyRechargeLimitedTitle: "Limited recharge bonus",
  cinema_firstRechargeLimitedBonus: "Extra {{percent}}% on any amount",
  cinema_rechargePayMethod: "Payment Method",
  cinema_rechargePay: "Pay",
  cinema_rechargeNoPackages: "No recharge plans are currently available",
  cinema_paymentUnavailable: "Payment is currently unavailable. Please contact support.",
  cinema_follow: "Follow",
  cinema_collect: "Collect",
  cinema_share: "Share",
  cinema_loading: "Loading...",
  cinema_favorites: "Favorites",
  cinema_emptyFavorites: "No favorite series yet",
  cinema_emptyPurchases: "No purchased series yet",
  cinema_clearAllConfirm: "Clear all watch history?",
  cinema_episodesUnit: "Episodes",
  cinema_lastWatched: "Last watched episode {{episode}}",
  cinema_purchasedEpisodes: "{{count}} episodes unlocked",
  cinema_account: "Account",
  cinema_accountName: "Display name",
  cinema_accountEmail: "Email",
  cinema_shareCode: "Share code",
  cinema_saveProfile: "Save profile",
  cinema_profileSaved: "Profile saved",
  cinema_profileSaveFailed: "Failed to save profile",
  cinema_accountInfo: "Basic information",
  cinema_changePassword: "Change password",
  cinema_newPassword: "New password",
  cinema_confirmPassword: "Confirm new password",
  cinema_passwordHint: "Use at least 6 characters",
  cinema_passwordMismatch: "The passwords do not match",
  cinema_passwordSaved: "Password updated",
  cinema_passwordSaveFailed: "Failed to update password",
  cinema_savePassword: "Save password",
  cinema_pointsBalance: "Coin balance",
  cinema_coinLedger: "Coin Ledger",
  cinema_businessReference: "Reference",
  cinema_emptyPointLogs: "No coin history yet",
  cinema_pointLog_registerReward: "Registration reward",
  cinema_pointLog_appFirstLoginReward: "First App login reward",
  cinema_pointLog_inviteReward: "Invitation reward",
  cinema_pointLog_dailyCheckIn: "Daily check-in reward",
  cinema_pointLog_limitedRechargeTask: "Limited first recharge task reward",
  cinema_pointLog_emailBindingTask: "Email binding task reward",
  cinema_pointLog_dailyUnlockTask: "Daily episode unlock task reward",
  cinema_bindEmailTaskTitle: "Bind Email",
  cinema_dailyUnlockTaskTitle: "Unlock {{count}} new episodes",
  cinema_unlockAction: "Unlock",
  cinema_dailyTaskProgress: "Today's progress {{current}}/{{target}} (Episode 1 excluded)",
  cinema_pointLog_firstEpisodeUnlock: "First episode pass unlock",
  cinema_pointLog_episodeUnlock: "Episode unlock",
  cinema_pointLog_recharge: "Recharge credited",
  cinema_pointLog_firstRechargeBonus: "First recharge bonus",
  cinema_pointLog_dailyRechargeBonus: "Limited recharge bonus",
  cinema_pointLog_adminAdjust: "Admin adjustment",
  cinema_pointLog_other: "Coin change",
  cinema_pointBiz_register: "Registration",
  cinema_pointBiz_registerBackfill: "Registration reward backfill",
  cinema_pointBiz_appFirstLogin: "First App login",
  cinema_pointBiz_inviteRegister: "Invited registration",
  cinema_pointBiz_dailyCheckIn: "Daily check-in",
  cinema_pointBiz_legacyLimitedRechargeTask: "24-hour recharge task",
  cinema_pointBiz_limitedRechargeTask: "1-hour first recharge task",
  cinema_pointBiz_emailBindingTask: "Email binding task",
  cinema_pointBiz_unlockThreeEpisodes: "Daily unlock 3 episodes task",
  cinema_pointBiz_unlockFiveEpisodes: "Daily unlock 5 episodes task",
  cinema_pointBiz_episodeUnlock: "Episode unlock",
  cinema_pointBiz_rechargeOrder: "Recharge order",
  cinema_pointBiz_adminAdjust: "Admin adjustment",
  cinema_pointBiz_other: "Other business",
  cinema_playbackAutoplay: "Autoplay next episode",
  cinema_playbackAutoplayDesc: "Automatically continue when an episode ends",
  cinema_aboutDesc: "My Fantasy brings you continuously updated short drama content.",
  cinema_rechargeOrders: "Recharge Ledger",
  cinema_myRechargeRecords: "View my recharge records",
  cinema_totalInvites: "Total Invites",
  cinema_distributionStats: "Promotion Statistics",
  cinema_distributionStatsDesc: "Browse visits, registrations, recharges, and commissions by date",
  cinema_summaryDate: "Date",
  cinema_summaryBrowse: "Views",
  cinema_summaryRegister: "Registrations",
  cinema_summaryRechargeCount: "Recharges",
  cinema_conversionRate: "Conversion Rate",
  cinema_commissionRatio: "Commission Ratio",
  cinema_browseDetails: "View Details",
  cinema_browseTime: "View Time",
  cinema_browseDrama: "Drama",
  cinema_browseRegion: "Region",
  cinema_noBrowseData: "No view records yet",
  cinema_noSummaryData: "No summary data yet",
  cinema_rewarded: "Rewarded",
  cinema_registered: "Registered",
  cinema_close: "Close",
  cinema_emptyRechargeOrders: "No recharge records yet",
  cinema_rechargeRecords: "Recharge Ledger",
  cinema_commissionRecords: "Commission Ledger",
  cinema_rechargeTime: "Recharge Time",
  cinema_paymentMethod: "Payment Method",
  cinema_paymentStatus: "Payment Status",
  cinema_orderNo: "Order Number",
  cinema_noRechargeRecords: "No recharge records yet",
  cinema_commissionTime: "Commission Time",
  cinema_commissionLevel: "Commission Level",
  cinema_commissionRate: "Commission Rate",
  cinema_noCommissionRecords: "No commission records yet",
  cinema_search: "Search",
  cinema_reset: "Reset",
  cinema_previousPage: "Previous",
  cinema_nextPage: "Next",
  cinema_paymentStatus_created: "Created",
  cinema_paymentStatus_pending: "Awaiting payment",
  cinema_paymentStatus_paid: "Recharge complete",
  cinema_paymentStatus_failed: "Payment failed",
  cinema_paymentStatus_closed: "Closed",
  cinema_paymentStatus_expired: "Expired",
  cinema_paymentAwaiting: "Order created. Complete payment on the payment page. If it fails, check that your VPN is turned off.",
  cinema_usdtAddress: "Receiving address",
  cinema_usdtNetwork: "TRC20 network only",
  cinema_copy: "Copy",
  cinema_copied: "Copied",
  cinema_playerSettings: "Playback settings",
  cinema_playerQuality: "Quality",
  cinema_playerSpeed: "Playback speed",
  cinema_playerAuto: "Auto",
  cinema_playerSource: "Original",
  cinema_playerSubtitles: "Subtitles",
  cinema_subtitleAuto: "Auto subtitles",
  cinema_subtitleOff: "Subtitles off",
  cinema_appDownloadTitle: "Watch the next episode more reliably in the App",
  cinema_appDownloadDesc: "Remember your progress and get notified about updates.",
  cinema_appDownloadReward: "Download the App and get {{points}} bonus coins on your first login!",
  cinema_homeAppDownloadReward: "Get {{points}} bonus coins when you log in with the App!",
  cinema_shareEarnPoints: "Share & Earn",
  cinema_shareLinkLabel: "Share link",
  cinema_shareRewardUnlimited: "Earn {{points}} coins for every new user who joins through your link, with no limit!",
  cinema_loginForShareLink: "Log in to get your share link",
  cinema_viewReferralStats: "View Referral Stats",
  cinema_episodeFinished: "Episode Finished",
  cinema_unlockNextEpisode: "Unlock Next Episode",
  cinema_changeDrama: "Change Video",
  cinema_allUnlocked: "All Unlocked",
  cinema_appDownloadButton: "Download App",
  cinema_appDownloadUnavailable: "The download is not available yet",
  cinema_rechargeAppPromptTitle: "Download the App for Bonus Coins",
  cinema_rechargeAppPromptReward: "Download and log in to get {{points}} extra coins!",
  cinema_rechargeAppPromptDesc: "Enjoy more reliable playback and automatic watch progress in the App.",
  cinema_appDownloadQr: "Scan to download the App",
  cinema_ageGateBadge: "Age verification",
  cinema_ageGateTitle: "Adult Content Notice",
  cinema_ageGateDescription: "This website contains fictional AI-generated content intended for adults only. By continuing, you confirm that you are at least 18 years old and agree to comply with the laws in your location.",
  cinema_ageGateUnderage: "If you are under 18, please leave this website now.",
  cinema_ageGateConfirm: "I am 18 or older — enter website",
  cinema_creatorCenter: "Creator Center",
  cinema_creatorCenterDesc: "Create your stories, share your world",
  cinema_creatorCenterNote: "Note: Non-original works must be free of watermarks",
  cinema_creatorMemberReady: "You're a VIP member, apply in one click",
  cinema_creatorBecome: "Become a Creator",
  cinema_creatorGateDesc: "Bring your stories to Huangguo TV. Once approved, your works go live on the cinema for millions of viewers to see your talent and earn premium subscription revenue shares.",
  cinema_creatorApplyBtn: "Apply to Become a Creator",
  cinema_creatorBenefitTitle: "Creator Benefits",
  cinema_creatorBenefit1: "Get your works listed with a dedicated \"Original\" tag",
  cinema_creatorBenefit2: "Track views, subscriptions and revenue share in real time",
  cinema_creatorBenefit3: "Unlock more creation tools and promotion resources",
  cinema_creatorReviewTip: "Applications and works are reviewed by the platform and must follow community guidelines.",
  cinema_creatorLevel: "Verified Creator",
  cinema_creatorOriginal: "Original",
  cinema_creatorSince: "Creator since",
  cinema_creatorAddWork: "Upload New Work",
  cinema_creatorTabOverview: "Overview",
  cinema_creatorTabWorks: "My Works",
  cinema_creatorTabUpload: "Upload",
  cinema_creatorTabPlatform: "Studio",
  cinema_creatorSubmitted: "Submitted, waiting for review",
  cinema_creatorStatViews: "Total Views",
  cinema_creatorStatSubs: "Total Subscribers",
  cinema_creatorStatRevenue: "Total Revenue",
  cinema_creatorStatWithdraw: "Withdrawable",
  cinema_creatorStatWorks: "Works",
  cinema_creatorStatReview: "In Review",
  cinema_creatorStatRejected: "Rejected",
  cinema_creatorTopWork: "Best Performing Work",
  cinema_creatorViews: "Views",
  cinema_creatorSubscriptions: "Subscribers",
  cinema_creatorShare: "Revenue",
  cinema_creatorNoPublished: "No published works yet",
  cinema_creatorFilterPublished: "Published",
  cinema_creatorFilterReview: "In Review",
  cinema_creatorFilterRejected: "Rejected",
  cinema_creatorWorksTitle: "My Works",
  cinema_creatorNoWorks: "No works yet, upload your first one",
  cinema_creatorGoUpload: "Upload Now",
  cinema_creatorStatusPublished: "Published",
  cinema_creatorStatusReview: "In Review",
  cinema_creatorStatusApproved: "Waiting to Transcode",
  cinema_creatorStatusTranscoding: "Transcoding",
  cinema_creatorStatusReady: "Waiting to Publish",
  cinema_creatorStatusTranscodeFailed: "Transcode Failed",
  cinema_creatorStatusPublishFailed: "Publish Failed",
  cinema_creatorStatusRejected: "Rejected",
  cinema_creatorPublishedOn: "Published on",
  cinema_creatorSubmittedOn: "Submitted on",
  cinema_creatorRejectedTip: "Rejected · Submitted on",
  cinema_creatorWorkName: "Work Title",
  cinema_creatorWorkNamePh: "Enter a work title",
  cinema_creatorCategory: "Category",
  cinema_creatorCover: "Cover",
  cinema_creatorCoverHint: "Upload one portrait cover image",
  cinema_creatorCoverUrlPh: "Paste an image link (optional)",
  cinema_creatorSynopsis: "Synopsis",
  cinema_creatorSynopsisPh: "Describe your story in a sentence or two…",
  cinema_creatorEpisodeTitle: "Episodes",
  cinema_creatorEpisodeDesc: "Add a title and upload one MP4 video for every episode",
  cinema_creatorEpisodeTitlePh: "Episode title",
  cinema_creatorEpisodeDurPh: "Duration (min)",
  cinema_creatorAddEpisode: "Add Episode",
  cinema_creatorEpShort: "Ep {{count}}",
  cinema_creatorEpisodeUpload: "Upload MP4",
  cinema_creatorEpisodeUploading: "Uploading…",
  cinema_creatorEpisodeReplace: "Replace video",
  cinema_creatorEpisodeMp4Only: ".mp4 files only, up to 100 MB per file",
  cinema_creatorEpisodeTypeError: "Each episode must be an .mp4 video",
  cinema_creatorEpisodeSizeError: "Each episode video must be no larger than 100 MB",
  cinema_creatorEpisodeUploadFailed: "Episode upload failed. Please try again.",
  cinema_creatorEpisodeRequired: "Add a title and upload an MP4 video for every episode",
  cinema_creatorRequired: "Please fill in a title and pick a cover first",
  cinema_creatorWorkNameRequired: "Enter a work title",
  cinema_creatorCategoryRequired: "Select a category",
  cinema_creatorCoverRequired: "Upload a cover image",
  cinema_creatorEpisodeTitleRequired: "Enter an episode title",
  cinema_creatorEpisodeVideoRequired: "Upload an MP4 video for this episode",
  cinema_creatorSubmit: "Submit for Review",
  cinema_creatorPlatformTag: "Creator Recommended",
  cinema_creatorPlatformTitle: "Creation Tool Platform",
  cinema_creatorPlatformDesc: "Head to the official creation platform for pro tools, script inspiration and assets to bring your story to life and publish it.",
  cinema_creatorPlatformPoint1: "AI Scripts & Ideas",
  cinema_creatorPlatformPoint2: "Pro Creation & Upload Tools",
  cinema_creatorPlatformPoint3: "Traffic Support & Payouts",
  cinema_creatorPlatformOpen: "Go to Creation Platform",
  cinema_creatorEarnBannerTitle: "Bring Your Story to the Cinema",
  cinema_creatorEarnBannerDesc: "Become a creator, upload works and earn from views, subscriptions and revenue share",
  cinema_creatorEarnBannerBtn: "Open Creator Center",
  cinema_creatorApplyFailed: "Application failed. Please try again.",
  cinema_creatorSubmitFailed: "Submission failed. Please try again.",
  cinema_creatorSubmitting: "Submitting…",
  cinema_creatorCategoryEmpty: "No categories available",
  cinema_creatorCoverUpload: "Upload cover",
  cinema_creatorCoverUploading: "Uploading…",
  cinema_creatorCoverChoose: "Choose image",
  cinema_creatorCoverReplace: "Replace image",
  cinema_creatorCoverRemove: "Remove",
  cinema_creatorCoverFormat: "JPG, PNG, WebP or GIF, up to 10 MB. One image only.",
  cinema_creatorCoverTypeError: "Choose a JPG, PNG, WebP or GIF image",
  cinema_creatorCoverSizeError: "Cover image must be no larger than 10 MB",
  cinema_creatorCoverUploadFailed: "Cover upload failed. Please try again.",
  cinema_creatorUploadNoticeTitle: "Upload Guidelines",
  cinema_creatorUploadNotice1: "All uploaded resources, original or otherwise, must be free of watermarks.",
  cinema_creatorUploadNotice2: "Original creators may contact our business team to register copyright ownership.",
  cinema_creatorUploadNotice3: "Final episode pricing is determined by the platform.",
  cinema_creatorUploadNotice4: "Each episode must be at least 150 seconds long.",
  cinema_creatorUploadNoticeConfirm: "I understand, continue",
};
